var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgWinRate = function SvgWinRate(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#FFD766",
    clipPath: "url(#win-rate_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M2.744 26.116h3.841c.24 0 .436.19.436.427v3.03a.43.43 0 0 1-.436.427H2.744a.43.43 0 0 1-.437-.427v-3.03c0-.236.196-.427.437-.427M13.42 23.207H9.58a.43.43 0 0 0-.437.427v5.939c0 .236.195.427.436.427h3.842a.43.43 0 0 0 .436-.427v-5.939a.43.43 0 0 0-.436-.427M16.415 20.298h3.842c.24 0 .436.19.436.427v8.848a.43.43 0 0 1-.437.427h-3.84a.43.43 0 0 1-.436-.427v-8.848c0-.236.196-.427.436-.427zM25.728 10.171a.71.71 0 0 0-1.112 0l-4.127 5.28c-.353.45-.024 1.102.555 1.102h1.77v13.02c0 .236.195.427.436.427h3.842a.43.43 0 0 0 .436-.427v-13.02h1.77c.58 0 .91-.651.557-1.102z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "win-rate_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
};
export default SvgWinRate;